export default __webpack_public_path__ + "static/media/money-back.76298bb1.png";